module.exports = __webpack_public_path__ + "img/file-back.5d95ab16.png";